import React from 'react';
import Reports from 'components/WorkflowReports';
const WorkflowReports = () => {
  return <Reports />;
};
export default WorkflowReports;
